import { createAction, props } from '@ngrx/store';
import { Toast } from '../../models';

export const addMessageToLog = createAction('[Messages] Add Message', props<{ message: string }>());
export const addToast = createAction('[Message] Add Toast', props<{ toast: Toast }>());
export const removeToast = createAction('[Message] Remove Toast', props<{ id: string }>());
